<template>
    <div>
        <vue-rangedate-picker format="DD/MM/YYYY" :initRange="range" :captions="captions" :preset-ranges="presetRanges" :months="months" :shortDays="shortDays" i18n="EN" @selected="setDates"></vue-rangedate-picker>
        <input type="hidden" name="date_from" v-model="range.start"/>
        <input type="hidden" name="date_to" v-model="range.end"/>
    </div>
</template>

<script>
    export default {
        name: 'RangeDate',
        data() {
            return {
                days: {
                    Maandag: 1,
                    Dinsdag: 2,
                    Woensdag: 4,
                    Donderdag: 8,
                    Vrijdag: 16,
                    Zaterdag: 32,
                    Zondag: 64
                },
                range: {
                    start: moment().startOf('day').format('DD/MM/YYYY'),
                    end: moment().endOf('day').format('DD/MM/YYYY')
                },
                presetRanges: {
                    today: () => {
                        return {
                            label: 'Vandaag',
                            active: true,
                            dateRange: {
                                start: moment().startOf('day').toDate(),
                                end: moment().endOf('day').toDate()
                            }
                        }
                    },
                    tomorrow: () => {
                        return {
                            label: 'Morgen',
                            active: true,
                            dateRange: {
                                start: moment().add(1, 'day').startOf('day').toDate(),
                                end: moment().add(1, 'day').endOf('day').toDate()
                            }
                        }
                    },
                    twoDays: () => {
                        return {
                            label: 'Overmorgen',
                            active: true,
                            dateRange: {
                                start: moment().add(2, 'day').startOf('day').toDate(),
                                end: moment().add(2, 'day').endOf('day').toDate()
                            }
                        }
                    },
                },
                months: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
                shortDays: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
                captions: {
                    'title': 'Kies datums',
                    'ok_button': 'Opslaan'
                }
            }
        },
        methods: {
            setDates(range) {
                this.range.start = moment(range.start).format('YYYY-MM-DD');
                this.range.end = moment(range.end).format('YYYY-MM-DD');
            }
        }
    }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// resources/js/components/RangeDate.vue